import React, { memo, useEffect, useMemo, useRef } from "react";
import { Props } from "./models";
import { confettiDefaults, extractCanvasProps } from "./utils";
import { Confetti } from "./confetti";
import "./main.css"

// insprired from https://www.npmjs.com/package/react-confetti

const CongratsComponent = React.forwardRef<HTMLCanvasElement, Props>((props, ref) => {
    return <InnerCongratsComponent canvasRef={ref} {...props} />
})

const InnerCongratsComponent: React.FC<Props> = (props) => {
    const finalProps = useMemo(() => ({ ...confettiDefaults, ...props }), [props])
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const canvasInstance = finalProps.canvasRef as React.RefObject<HTMLCanvasElement> || useRef(null)
    const confettiInstance = useRef(null)

    useEffect(() => {
        if (canvasInstance.current) {
            const opts = extractCanvasProps(finalProps)[0]
            confettiInstance.current = new Confetti(canvasInstance.current, opts)
        }

        return () => {
            if (confettiInstance.current) {
                confettiInstance.current.stop()
            }
            confettiInstance.current = null
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [confettiOptions, passedProps] = useMemo(() => extractCanvasProps(finalProps), [finalProps])

    const canvasStyles = useMemo(() => {
        return {
            zIndex: 2,
            position: 'absolute' as any,
            pointerEvents: 'none' as any,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            transition: "opacity 1s ease-in-out, visibility 1s ease-in-out",
            ...passedProps.style,
        }
    }, [passedProps])

    return (
        <canvas
            className={finalProps.showCongrats ? 'congratsCanvasVisible' : 'congratsCanvasHidden'}
            width={confettiOptions.width}
            height={confettiOptions.height}
            ref={canvasInstance}
            {...passedProps}
            style={canvasStyles}
        />
    )
}

export default memo(CongratsComponent);
